import { render, staticRenderFns } from "./shops-map-view.vue?vue&type=template&id=53e74a20&scoped=true"
import script from "./shops-map-view.vue?vue&type=script&lang=js"
export * from "./shops-map-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e74a20",
  null
  
)

export default component.exports